"use strict";
/**
 * Shared filter types for candidate search
 * Used by both the webapp and extension for consistent filter handling
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.createEmptySearchFilters = void 0;
// Helper to create empty filter state
const createEmptySearchFilters = () => ({
    candidateDetails: {
        jobTitles: { values: [], aggregator: 'or' },
        skills: { values: [], aggregator: 'or' },
        keywords: { values: [], aggregator: 'or' },
        spokenLanguages: [],
    },
    location: {
        locations: { values: [], aggregator: 'or' },
        postalCodes: [],
        remoteOnly: false,
    },
    education: {
        degreeTypes: [],
        fieldsOfStudy: [],
        schools: [],
        graduationYearRange: {},
    },
    experience: {
        yearsOfExperience: {},
        yearsInCurrentCompany: {},
        yearsInCurrentPosition: {},
        seniority: [],
    },
    company: {
        currentCompanies: { values: [], aggregator: 'or' },
        pastCompanies: { values: [], aggregator: 'or' },
        companySizes: [],
        industries: { values: [], aggregator: 'or' },
    },
    recruitingActivity: {
        openToWork: null,
        recentlyChanged: false,
        hasConnections: null,
    },
});
exports.createEmptySearchFilters = createEmptySearchFilters;
